import { Box, Text, TextProps } from '@jfs/ui-new'
import { FC } from 'react'

interface FormTextProps extends TextProps {
  marginHorizontal: number
  text: string
}

const FormText: FC<FormTextProps> = ({ marginHorizontal, text, ...textProps }: FormTextProps) => {
  return (
    <Box marginHorizontal={marginHorizontal}>
      <Text {...textProps}>{text}</Text>
    </Box>
  )
}

export { FormText }
